'use client';

import { useMemo, useCallback } from 'react';
import { getCountries } from '@/lib/data-source';
import { getSlugForCountry, uiFb } from '@/lib/i18n';
import type { CountryCode } from '@/lib/types';
import { CountryCombobox, type ComboboxCountry } from '@/components/ui/CountryCombobox';

interface NavCountryLinksProps {
  currentLang: string;
  activeCountryCode?: string;
}

export function NavCountryLinks({ currentLang, activeCountryCode }: NavCountryLinksProps) {
  const comboboxCountries: ComboboxCountry[] = useMemo(
    () => getCountries().map(c => ({ code: c.code, name: c.name, region: c.region })),
    [],
  );

  const handleChange = useCallback(
    (code: string) => {
      const slug =
        getSlugForCountry(code as CountryCode, currentLang) ||
        getSlugForCountry(code as CountryCode, 'en');
      if (slug) {
        window.location.href = '/' + slug;
      }
    },
    [currentLang],
  );

  return (
    <CountryCombobox
      countries={comboboxCountries}
      value={activeCountryCode ?? null}
      onChange={handleChange}
      variant="nav-link"
      mode="navigate"
      label={uiFb('ui.select_country', 'Select Country', currentLang)}
    />
  );
}
